import { Rectangle, } from '@printu/geom';
import { getTypeFactory } from 'app/core/markers/getTypeFactory';
import { getMarkerLayer } from 'app/core/markers/models';
import { applyCrop } from 'app/utils/geom';
export const createImage = getTypeFactory('Image', {
    scale: 1,
});
export const createPage = getTypeFactory('Page', {
    blurs: [],
    spots: [],
    marks: [],
    pins: [],
    texts: [],
    style: undefined,
    //  {
    //     // background: {
    //     //     type: 'gradient',
    //     //     rotation: 60,
    //     //     colors: [
    //     //         '#3F51B1',
    //     //         '#8F6AAE',
    //     //         '#CC6B8E',
    //     //         '#F18271',
    //     //         '#F3A469',
    //     //         '#F7C978',
    //     //     ],
    //     // },
    //     background: {
    //         type: 'solid',
    //         color: 'pink',
    //     },
    //     inset: 0,
    //     padding: 0,
    //     shadow: 0,
    //     corner: 0,
    // },
});
export const getPageKeyFromMarkerLayer = (layer) => {
    switch (layer) {
        case 0:
            return 'blurs';
        case 1:
            return 'spots';
        case 2:
            return 'marks';
        case 3:
            return 'pins';
        case 4:
            return 'texts';
        default:
            break;
    }
    return undefined;
};
export const getPageKeyForMarkerAlias = (alias) => getPageKeyFromMarkerLayer(getMarkerLayer(alias));
// switch (alias) {
//     case 'Blur':
//         return 'blurs';
//     case 'Spot':
//         return 'spots';
//     case 'Text':
//         return 'texts';
//     case 'Pin':
//         return 'pins';
//     default:
//         return 'marks';
// }
export const getPageBounds = (page, image) => {
    const { image: imageId } = page;
    if (imageId !== image.id) {
        return null;
    }
    if (!image) {
        return { x: 0, y: 0, width: 0, height: 0 };
    }
    const bleedBox = Object.assign({ x: 0, y: 0 }, image.size);
    return bleedBox;
};
export const getPageRect = (page, image) => {
    const bounds = getPageBounds(page, image);
    return bounds ? applyCrop(bounds, page.crop) : undefined;
};
export const getPageBleedBox = (page, image) => {
    let bleedBox = getPageRect(page, image);
    if (page.style) {
        const padding = Math.max(0, page.style.padding);
        if (padding) {
            const pageRect = Rectangle.from(bleedBox);
            bleedBox = pageRect.inflate(padding, padding).toObject();
        }
    }
    return bleedBox;
};
